export default {"src":"/_next/static/media/icon-industrial.777e90c9.svg","height":29,"width":30,"blurWidth":0,"blurHeight":0};